import { Business } from '@type/buzzkuri/common'

type Props = Business

export const LoggedInUserInfo = ({
  userName,
  name,
  remainingTicketNumber,
  totalTicketNumber,
  planEffectiveDate, //ex: '2021年10月22日'
}: Props): JSX.Element => (
  <div>
    <div className="text-[3.7vw] text-[#333]">{name}</div>
    <div className="mt-[1.3vw] text-[5.3vw] font-bold text-[#333]">
      {userName}さん
    </div>
    <div className="mt-[5vw]">
      <div className="text-[3.7vw] text-[#333]">
        サービス利用可能回数:{' '}
        <span className="font-bold">
          {`${remainingTicketNumber}/${totalTicketNumber}`}
        </span>
      </div>
      <div className="mt-[1.6vw]">
        <div className="text-[3.7vw] text-[#333]">
          サービス利用期限:{' '}
          <span className="font-bold">{planEffectiveDate}</span>
        </div>
      </div>
    </div>
  </div>
)
